/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MailTemplateEntity,
  UpdateMailTemplateDto,
} from '../models/index';
import {
    MailTemplateEntityFromJSON,
    MailTemplateEntityToJSON,
    UpdateMailTemplateDtoFromJSON,
    UpdateMailTemplateDtoToJSON,
} from '../models/index';

export interface DeleteMailTemplateRequest {
    type: string;
}

export interface UpdateMailTemplateRequest {
    type: string;
    updateMailTemplateDto: UpdateMailTemplateDto;
}

/**
 * 
 */
export class MailTemplateApi extends runtime.BaseAPI {

    /**
     * 保存済みメールテンプレートを削除しデフォルトへ戻す。
     */
    async deleteMailTemplateRaw(requestParameters: DeleteMailTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailTemplateEntity>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling deleteMailTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/mailTemplates/{type}`.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailTemplateEntityFromJSON(jsonValue));
    }

    /**
     * 保存済みメールテンプレートを削除しデフォルトへ戻す。
     */
    async deleteMailTemplate(requestParameters: DeleteMailTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailTemplateEntity> {
        const response = await this.deleteMailTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * テナントのメールテンプレート一覧を取得する。
     */
    async listMailTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MailTemplateEntity>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/mailTemplates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MailTemplateEntityFromJSON));
    }

    /**
     * テナントのメールテンプレート一覧を取得する。
     */
    async listMailTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MailTemplateEntity>> {
        const response = await this.listMailTemplatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * メールテンプレートを保存する。
     */
    async updateMailTemplateRaw(requestParameters: UpdateMailTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailTemplateEntity>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling updateMailTemplate().'
            );
        }

        if (requestParameters['updateMailTemplateDto'] == null) {
            throw new runtime.RequiredError(
                'updateMailTemplateDto',
                'Required parameter "updateMailTemplateDto" was null or undefined when calling updateMailTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/mailTemplates/{type}`.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMailTemplateDtoToJSON(requestParameters['updateMailTemplateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailTemplateEntityFromJSON(jsonValue));
    }

    /**
     * メールテンプレートを保存する。
     */
    async updateMailTemplate(requestParameters: UpdateMailTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailTemplateEntity> {
        const response = await this.updateMailTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
